import { getStorage } from '@/shared/utils/general.util';
import STORAGE_KEYS from '@/shared/constants/storage';

/**
 * Cuenta de intentos de vinculación FALLIDOS del usuario, para ofrecerle una
 * salida humana cuando ya no la va a sacar solo.
 *
 * Cuenta los dos métodos juntos —CIEC y e.firma— a propósito: quien falla dos
 * veces con su contraseña y una con su e.firma es exactamente el usuario que
 * queremos rescatar, y separar los contadores lo dejaría sin ayuda pese a
 * llevar tres tropiezos.
 *
 * Vive en storage y no en estado de React porque un fallo tira al usuario de
 * vuelta al formulario y muchos recargan la página: un contador en memoria se
 * reiniciaría justo con el que más lo necesita. Se limpia al vincular (el
 * problema se resolvió) y en el reset del workflow.
 */
export const SUPPORT_RESCUE_AFTER_ATTEMPTS = 3;

/** Mensaje con el que arranca la conversación del chat. Lo lee el agente
 * como primer contexto, así que dice el problema, no un saludo. */
export const SUPPORT_RESCUE_MESSAGE =
	'Necesito ayuda para vincular mis credenciales';

export const readFailedAttempts = (): number => {
	const raw = Number(getStorage().getItem(STORAGE_KEYS.LINKING_FAILED_ATTEMPTS));
	return Number.isFinite(raw) && raw > 0 ? raw : 0;
};

export const bumpFailedAttempts = (): number => {
	const next = readFailedAttempts() + 1;
	getStorage().setItem(STORAGE_KEYS.LINKING_FAILED_ATTEMPTS, String(next));
	return next;
};

export const clearFailedAttempts = (): void => {
	getStorage().removeItem(STORAGE_KEYS.LINKING_FAILED_ATTEMPTS);
	getStorage().removeItem(STORAGE_KEYS.LINKING_RESCUE_DISMISSED);
};

/**
 * En qué número de tropiezos el usuario cerró la ayuda prioritaria.
 *
 * La ayuda se abre sola, así que sin memoria volvería a saltar cada vez que el
 * paso 2 se monta —incluido volver al selector y elegir método de nuevo—, que
 * es exactamente el patrón de quien ya la vio y la cerró. Se guarda el CONTEO,
 * no un booleano: así un fallo nuevo (conteo mayor al cerrado) sí vuelve a
 * ofrecerla, que es cuando la oferta recupera sentido.
 */
export const readRescueDismissedAt = (): number => {
	const raw = Number(getStorage().getItem(STORAGE_KEYS.LINKING_RESCUE_DISMISSED));
	return Number.isFinite(raw) && raw > 0 ? raw : 0;
};

export const markRescueDismissed = (attempts: number): void => {
	getStorage().setItem(STORAGE_KEYS.LINKING_RESCUE_DISMISSED, String(attempts));
};
